import React from "react";
import Checkbox from "./Checkbox";

const Radio = (props) => <Checkbox {...props} type="radio" />;

export default Radio;
